import * as React from 'react';
import { css } from '@emotion/core';
import Card from '../../layout/card/Card';
import { Str } from '../../localization/translationKeys';
import LocalDiv from '../../localization/LocalDiv';
import LocalBtn from '../../localization/LocalBtn';
import Spacer from '../../layout/Spacer';
import { FLEX_COLUMN, FLEX_ROW } from '../../layout/flexBox';
import { COLORS } from '../../globalStyle/colors';
import { btnStyle } from '../../forms/styles/button';
import { GoalAnswer } from './models';
import { useFormik } from 'formik';
import LocalTextArea from '../../localization/LocalTextArea';
import { FIELDSET_DEFAULT } from '../../layout/fieldSetStyle';


const BTN_STYLE = css`
  min-width: 80px;
`;

const styles = {
  root:         [
    FLEX_COLUMN,
    css`
    padding: 0;
    margin-bottom: 20px;
    background-color: transparent;
    `,
  ],
  textArea:     [
    css`
      width: 100%;  
      padding: 10px;
      color: #474747;
      box-sizing: border-box;
      border: none;
      border-radius: 8px;
    `,
  ],
  buttonRow:    [
    FLEX_ROW,
    css`
      margin: 10px 16px 0 0;
      justify-content: flex-start;
    `,
  ],
  submitButton: [
    btnStyle.primary(COLORS.BLUE),
    BTN_STYLE,
  ],
  cancelButton: [
    btnStyle.transparent(COLORS.BLUE),
    BTN_STYLE,
    css`
      border: none;
    `,
  ],
};


type Props = {
  className?: string;
  goalAnswer: GoalAnswer;
  saveAnswer: (answer: string) => void;
  handleClick: () => void;
  handleCancel: () => void;
  inEditMode: boolean;
};


/**
 * Answer: a component that handles a goal answer
 *
 * PureComponent: true
 * Redux Connected: false
 */
const Answer: React.FC<Props> = props => {
  const editMode = props.inEditMode;

  const { handleSubmit, handleChange, resetForm, values } = useFormik({
    initialValues: {
      answer: props.goalAnswer.questionAnswer,
    },
    onSubmit: (values) => {
      props.saveAnswer(values.answer);
    },
    validateOnChange: false,
  });

  // TODO - this is all going to change based on Slack conversation 6/12
  //        will hold for now until Kellen works out strategy for Dev Plan

  return (
    <Card css={styles.root} className={props.className}>
      <fieldset css={FIELDSET_DEFAULT} >
        <form onSubmit={handleSubmit}>
          <LocalTextArea
            name='answer'
            value={values.answer || ''}
            css={[
              styles.textArea,
              css`background-color: ${editMode ? COLORS.WHITE : COLORS.LIGHTEST_GREY}`,
            ]}
            rows={4}
            placeholderTranslation={Str.ResponseNotAdded}
            onClick={props.handleClick}
            onChange={handleChange}
          />
          {
            editMode && (
              <LocalDiv css={styles.buttonRow}>
                <LocalBtn type='submit' css={styles.submitButton} str={Str.Save} />
                <Spacer sizePx={12}/>
                <LocalBtn
                  type='button'
                  onClick={() => {props.handleCancel(); resetForm();}}
                  css={styles.cancelButton} str={Str.Cancel}
                />
              </LocalDiv>
            )
          }
        </form>
      </fieldset>
    </Card>
  )
};

export default Answer;
